var map = {
	"./after_1.jpg": 8613,
	"./after_2.jpg": 7626,
	"./after_3.jpg": 6631,
	"./after_4.jpg": 2844,
	"./after_5.jpg": 217,
	"./after_6.jpg": 4078,
	"./before_1.jpg": 3546,
	"./before_2.jpg": 3266,
	"./before_3.jpg": 1243,
	"./before_4.jpg": 6459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;